module.exports = __webpack_public_path__ + "img/retaining-wall-4.2813ffe7.jpeg";